import { UserProfile } from '@api/models';

export class OauthUser {
	public id: string;
	public profile: Array<UserProfile>;
	public roleId: string;
	public dealerId: string;
	public branchId: string;
	public name: string;
	public lastName: string;
	public identificationNo: string;
	public email: string;
	public phone: string;
	public password: string;
	public passwordChangeDate: Date;
	public lastLoginDate: Date;
	public loginAttempt: number;
	public lockDate: Date;
	public activated: boolean;
	public activationKey: string;
	public resetPasswordKey: string;
	public language: string;
	public timeZone: string;
	public valid: boolean;
}
